import { render, staticRenderFns } from "./BaseStatisticItem.vue?vue&type=template&id=c73b1762&"
import script from "./BaseStatisticItem.vue?vue&type=script&lang=js&"
export * from "./BaseStatisticItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports